module.exports = __webpack_public_path__ + "static/img/8.330541e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Text/8.png
// module id = 355
// module chunks = 0